import { render } from "./MessageListItem.vue?vue&type=template&id=081ba65c&scoped=true"
import script from "./MessageListItem.vue?vue&type=script&lang=js"
export * from "./MessageListItem.vue?vue&type=script&lang=js"

import "./MessageListItem.vue?vue&type=style&index=0&id=081ba65c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-081ba65c"

export default script